<template>
    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
        <Loader></Loader>
        <button class="m-aside-left-close  m-aside-left-close--skin-dark " id="m_aside_left_close_btn">
            <i class="la la-close"></i>
        </button>
        <NavBar v-bind:activeMenu="activeMenuItem" :menu="menu"></NavBar>
        <div class="m-grid__item m-grid__item--fluid m-wrapper">
            <!-- BEGIN: Subheader -->
            <SubHeader v-bind:headerTitle="headerTitle" v-bind:add-new-link="newLink" v-bind:noexport="noexport" v-bind:nonew="nonew" v-bind:disable="disable"></SubHeader>
            <!-- END: Subheader -->
            <div class="m-content">
                <div class="row">
                    <div class="col-12">
                        <div class="m-portlet">
                            <div class="m-portlet__body">
                                <!--Begin::Section-->
                                <router-view v-on:updateTitle="updateTitle" v-on:activeMenu="activeMenu" v-on:newLink="updateNewLink" v-on:updateExport="updateExport" v-on:updateNew="updateNew" v-on:updateDisable="updateDisable"></router-view>
                                <!--End::Section-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end::Body -->
</template>

<script>
import NavBar from './NavBar'
import SubHeader from './SubHeader'
import RiseLoader from 'vue-spinner/src/RiseLoader'
import Loader from './Loader'
export default {
  name: 'Body',
  props: ['menu'],
  data () {
    return {
      loading: true,
      activeMenuItem: '/admin',
      headerTitle: 'Dashboard',
      newLink: '',
      noexport: false,
      nonew: false,
      disable: false
    }
  },
  components: {Loader, RiseLoader, SubHeader, NavBar},
  methods: {
    updateTitle: function (val) {
      this.headerTitle = val
    },
    updateNewLink: function (val) {
      this.newLink = val
    },
    activeMenu: function (val) {
      this.activeMenuItem = val
    },
    updateExport: function (val) {
      this.noexport = val
    },
    updateNew: function (val) {
      this.nonew = val
    },
    updateDisable: function (val) {
      this.disable = val
    }
  },
  watch: {
    activeMenuItem: {
      handler (val) {
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Body.vue